import firstUppercase from './firstUppercase';
import removeAsteriscos from './removeAsteriscos';

const getDesc = product => {
    return removeAsteriscos(
        product.desite
            .toLowerCase()
            .slice(7, product.desite.len)
            .split(' ')
            .map(p => firstUppercase(p))
            .join(' ')
    );
};

export default getDesc;
